import React from 'react';
import { useInView } from 'react-intersection-observer';

const ProcessFlow = ({ title, description, steps }) => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    return (
        <div
            ref={ref}
            className={`mt-12 transition-opacity duration-1000 ease-in-out ${inView ? 'opacity-100' : 'opacity-0'
                }`}
        >
            {(title || description) && (
                <div className="text-center mb-8">
                    {title && <h3 className="text-2xl font-bold mb-2">{title}</h3>}
                    {description && <p className="text-gray-600">{description}</p>}
                </div>
            )}

            <div className="flex flex-col md:flex-row items-start justify-between md:space-x-4 space-y-6 md:space-y-0">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className={`flex-1 transition-all duration-500 delay-${index * 100} ${inView ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
                            }`}
                    >
                        <div className="relative">
                            {/* 連接線 - 只在中間步驟顯示 */}
                            {index < steps.length - 1 && (
                                <div className="hidden md:block absolute top-10 left-1/2 right-0 h-0.5 bg-gray-200 w-full" style={{ transform: 'translateY(-50%)' }}></div>
                            )}

                            {/* 步驟圓圈 */}
                            <div className={`relative z-10 flex items-center justify-center w-20 h-20 mx-auto rounded-full ${step.color || 'bg-primary-100 text-primary-600'}`}>
                                {step.icon || (
                                    <span className="text-xl font-bold">{index + 1}</span>
                                )}
                            </div>
                        </div>

                        <div className="text-center mt-4 px-2">
                            <h4 className="text-lg font-semibold mb-2">{step.title}</h4>
                            <p className="text-sm text-gray-600">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProcessFlow;